const Logo02Icon = ({ className, ...props }: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="204"
      height="48"
      viewBox="0 0 204 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <foreignObject x="-20" y="-19.9668" width="72.2324" height="87.1865">
        <div
          style={{
            backdropFilter: 'blur(10px)',
            clipPath: 'url(#bgblur_0_637_16393_clip_path)',
            height: '100%',
            width: '100%',
          }}
        ></div>
      </foreignObject>
      <path
        data-figma-bg-blur-radius="20"
        d="M29.1426 0.283203H31.9072L20.9609 41.1201C20.0362 44.5696 16.9009 46.9697 13.3184 46.9697H0.385742L18.2021 7.34766C20.1345 3.05002 24.4178 0.283366 29.1426 0.283203Z"
        fill="url(#paint0_linear_637_16393)"
        stroke="white"
        strokeWidth="0.5"
      />
      <foreignObject x="33.0366" y="-20" width="190.962" height="88">
        <div
          style={{
            backdropFilter: 'blur(10px)',
            clipPath: 'url(#bgblur_1_637_16393_clip_path)',
            height: '100%',
            width: '100%',
          }}
        ></div>
      </foreignObject>
      <path
        data-figma-bg-blur-radius="20"
        d="M63.7905 0.25V26.0225C63.7905 30.541 64.722 33.8552 66.643 35.9014C68.5576 37.9406 71.2345 38.9463 74.6371 38.9463C78.0398 38.9463 80.7167 37.9406 82.6313 35.9014C84.5522 33.8551 85.4838 30.541 85.4838 26.0225V0.25H95.852V26.4268C95.852 33.3018 93.9637 38.5552 90.2211 42.2256C86.4756 45.8987 81.269 47.75 74.5688 47.75C67.8688 47.7499 62.6629 45.8986 58.9174 42.2256C55.1748 38.5552 53.2866 33.3018 53.2866 26.4268V0.25H63.7905ZM182.576 0.25L203.611 46.9414H192.618L188.461 36.9824L188.397 36.8291H166.023L165.958 36.9824L161.786 46.9414H151.063L172.031 0.25H182.576ZM123.123 0.25C129.699 0.250058 134.774 1.76985 138.382 4.77637L138.383 4.77734C141.986 7.73469 143.794 11.8398 143.794 17.124C143.794 20.5873 142.967 23.571 141.323 26.0859C139.677 28.5584 137.339 30.4617 134.299 31.793L134.206 31.834L133.925 31.9561L134.101 32.207L144.447 46.9414H133.171L124.118 33.8994L124.041 33.79L123.909 33.792C123.738 33.7942 123.567 33.7949 123.395 33.7949H113.567V46.9414H103.063V0.25H123.123ZM177 10.6289L169.433 28.6895L169.288 29.0361H185.145L185 28.6904L177.462 10.6299L177.232 10.0781L177 10.6289ZM113.567 25.5986H122.784C126.209 25.5986 128.814 24.8741 130.554 23.3809L130.557 23.3779C132.294 21.8403 133.155 19.7456 133.155 17.124C133.155 14.4589 132.295 12.3606 130.554 10.8662C128.814 9.37296 126.209 8.64846 122.784 8.64844H113.567V25.5986Z"
        fill="url(#paint1_linear_637_16393)"
        stroke="white"
        strokeWidth="0.5"
      />
      <foreignObject x="11.4179" y="3.59473" width="61.9057" height="63.5957">
        <div
          style={{
            backdropFilter: 'blur(10px)',
            clipPath: 'url(#bgblur_2_637_16393_clip_path)',
            height: '100%',
            width: '100%',
          }}
        ></div>
      </foreignObject>
      <path
        data-figma-bg-blur-radius="20"
        d="M52.9365 46.9404H41.9413L37.6796 36.9795L37.6142 36.8281H31.9521L42.6279 24.0605L52.9365 46.9404Z"
        fill="url(#paint2_linear_637_16393)"
        stroke="white"
        strokeWidth="0.5"
      />
      <foreignObject x="-20" y="-8.95898" width="77.1284" height="76.1777">
        <div
          style={{
            backdropFilter: 'blur(10px)',
            clipPath: 'url(#bgblur_3_637_16393_clip_path)',
            height: '100%',
            width: '100%',
          }}
        ></div>
      </foreignObject>
      <path
        data-figma-bg-blur-radius="20"
        d="M30.4141 11.291H36.7295L21.5869 42.5156C20.2664 45.2385 17.5002 46.9687 14.4658 46.9688H0.490234L24.0039 14.5557C25.3981 12.6337 27.5807 11.4457 29.9395 11.3047L30.4141 11.291Z"
        fill="url(#paint3_linear_637_16393)"
        stroke="white"
        strokeWidth="0.5"
      />
      <foreignObject x="-20" y="1.18555" width="81.8205" height="66.0342">
        <div
          style={{
            backdropFilter: 'blur(10px)',
            clipPath: 'url(#bgblur_4_637_16393_clip_path)',
            height: '100%',
            width: '100%',
          }}
        ></div>
      </foreignObject>
      <path
        data-figma-bg-blur-radius="20"
        d="M32.4189 21.4355H41.2793L21.8379 44.1963C20.3352 45.9557 18.1337 46.9696 15.8154 46.9697H0.657227L27.1572 23.4336C28.5153 22.2273 30.2458 21.5263 32.0557 21.4434L32.4189 21.4355Z"
        fill="url(#paint4_linear_637_16393)"
        stroke="white"
        strokeWidth="0.5"
      />
      <defs>
        <clipPath id="bgblur_0_637_16393_clip_path" transform="translate(20 19.9668)">
          <path d="M29.1426 0.283203H31.9072L20.9609 41.1201C20.0362 44.5696 16.9009 46.9697 13.3184 46.9697H0.385742L18.2021 7.34766C20.1345 3.05002 24.4178 0.283366 29.1426 0.283203Z" />
        </clipPath>
        <clipPath id="bgblur_1_637_16393_clip_path" transform="translate(-33.0366 20)">
          <path d="M63.7905 0.25V26.0225C63.7905 30.541 64.722 33.8552 66.643 35.9014C68.5576 37.9406 71.2345 38.9463 74.6371 38.9463C78.0398 38.9463 80.7167 37.9406 82.6313 35.9014C84.5522 33.8551 85.4838 30.541 85.4838 26.0225V0.25H95.852V26.4268C95.852 33.3018 93.9637 38.5552 90.2211 42.2256C86.4756 45.8987 81.269 47.75 74.5688 47.75C67.8688 47.7499 62.6629 45.8986 58.9174 42.2256C55.1748 38.5552 53.2866 33.3018 53.2866 26.4268V0.25H63.7905ZM182.576 0.25L203.611 46.9414H192.618L188.461 36.9824L188.397 36.8291H166.023L165.958 36.9824L161.786 46.9414H151.063L172.031 0.25H182.576ZM123.123 0.25C129.699 0.250058 134.774 1.76985 138.382 4.77637L138.383 4.77734C141.986 7.73469 143.794 11.8398 143.794 17.124C143.794 20.5873 142.967 23.571 141.323 26.0859C139.677 28.5584 137.339 30.4617 134.299 31.793L134.206 31.834L133.925 31.9561L134.101 32.207L144.447 46.9414H133.171L124.118 33.8994L124.041 33.79L123.909 33.792C123.738 33.7942 123.567 33.7949 123.395 33.7949H113.567V46.9414H103.063V0.25H123.123ZM177 10.6289L169.433 28.6895L169.288 29.0361H185.145L185 28.6904L177.462 10.6299L177.232 10.0781L177 10.6289ZM113.567 25.5986H122.784C126.209 25.5986 128.814 24.8741 130.554 23.3809L130.557 23.3779C132.294 21.8403 133.155 19.7456 133.155 17.124C133.155 14.4589 132.295 12.3606 130.554 10.8662C128.814 9.37296 126.209 8.64846 122.784 8.64844H113.567V25.5986Z" />
        </clipPath>
        <clipPath id="bgblur_2_637_16393_clip_path" transform="translate(-11.4179 -3.59473)">
          <path d="M52.9365 46.9404H41.9413L37.6796 36.9795L37.6142 36.8281H31.9521L42.6279 24.0605L52.9365 46.9404Z" />
        </clipPath>
        <clipPath id="bgblur_3_637_16393_clip_path" transform="translate(20 8.95898)">
          <path d="M30.4141 11.291H36.7295L21.5869 42.5156C20.2664 45.2385 17.5002 46.9687 14.4658 46.9688H0.490234L24.0039 14.5557C25.3981 12.6337 27.5807 11.4457 29.9395 11.3047L30.4141 11.291Z" />
        </clipPath>
        <clipPath id="bgblur_4_637_16393_clip_path" transform="translate(20 -1.18555)">
          <path d="M32.4189 21.4355H41.2793L21.8379 44.1963C20.3352 45.9557 18.1337 46.9696 15.8154 46.9697H0.657227L27.1572 23.4336C28.5153 22.2273 30.2458 21.5263 32.0557 21.4434L32.4189 21.4355Z" />
        </clipPath>
        <linearGradient
          id="paint0_linear_637_16393"
          x1="16.1162"
          y1="0.0332031"
          x2="16.1162"
          y2="47.2197"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.3" />
          <stop offset="1" stopColor="white" stopOpacity="0.3" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_637_16393"
          x1="128.517"
          y1="0"
          x2="128.517"
          y2="48"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0.3" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_637_16393"
          x1="42.3708"
          y1="23.5947"
          x2="42.3708"
          y2="47.1902"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0.3" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_637_16393"
          x1="18.5642"
          y1="11.041"
          x2="18.5642"
          y2="47.2191"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.5" />
          <stop offset="1" stopColor="white" stopOpacity="0.3" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_637_16393"
          x1="20.9102"
          y1="21.1855"
          x2="20.9102"
          y2="47.2194"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0.3" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Logo02Icon;
